export default __webpack_public_path__ + "static/media/pic6.d50d9fb5.jpg";